export async function fetchMilanStores() {
    // Dev: hit Firebase directly (no CDN locally). Prod/preview uses the cached Netlify function.
    if (process.env.NODE_ENV === 'development') {
        const collectionName = process.env.GATSBY_FIREBASE_MILAN_STORES_COLLECTION;
        if (!collectionName) {
            throw new Error('fetchMilanStores: GATSBY_FIREBASE_MILAN_STORES_COLLECTION is not set');
        }
        // Dynamic imports prevent Firebase client SDK from initializing during SSR/build.
        const [{ collection, getDocs }, { db }] = await Promise.all([
            import('firebase/firestore'),
            import('../firebase/firebase'),
        ]);
        const collectionRef = collection(db, collectionName);
        const snapshot = await getDocs(collectionRef);
        return snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    }

    const response = await fetch('/.netlify/functions/milan-stores');
    if (!response.ok) {
        const body = await response.text().catch(() => '');
        throw new Error(`milan-stores function responded with status ${response.status}: ${body}`);
    }
    return response.json();
}
